import { Directive, HostListener } from '@angular/core';
import { NgModel } from '@angular/forms';
import { EgonService } from '../services/egon.service';
import { DomicileService } from '../services/domicile.service';
import { ExceptionHttp } from '../services/api.service';
import { promise } from 'protractor';
import { resolve } from 'path';
import { take } from 'rxjs/operators';
import { ExpeditionsService } from '../services/expeditions.service';

@Directive({
    selector: '[zipCode]',
    exportAs: 'zipCode'
})
export class ZipCodeDirective {
    constructor(
        private houseService: DomicileService,
        private model: NgModel,
        private egonService: EgonService,
        private expeditionService: ExpeditionsService) {
    }
    private zipCodeSearched: string;
    @HostListener('blur', ['$event.target.value'])
    change(zipCode: string) {
        this.houseService.zipCode$.next(zipCode);
        if (zipCode.length > 3 && zipCode !== this.zipCodeSearched) {
            this.zipCodeSearched = zipCode;
            this.egonService.localities(zipCode)
                .pipe(take(1))
                .subscribe(localities => {
                    this.houseService.localities$.next(localities);
                }, (err: ExceptionHttp) => {
                    this.model.control.setValue('');
                    this.model.control.setErrors({ 'codigoPostalAgencia': err.message }, { emitEvent: true })
                    this.zipCodeSearched = '';
                    this.houseService.location$.next(null);
                    this.houseService.localities$.next([]);
                });
        }
    }
    async validate(zipCode: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            if (zipCode === this.zipCodeSearched) {
                resolve(true);
            } else {
                if (zipCode.length > 3 && zipCode !== this.zipCodeSearched) {
                    this.zipCodeSearched = zipCode;
                    this.egonService.localities(zipCode)
                        .pipe(take(1))
                        .subscribe(localities => {
                            this.houseService.localities$.next(localities);
                            resolve(true);
                        }, (err: ExceptionHttp) => {
                            this.model.control.setValue('');
                            this.model.control.setErrors({ 'codigoPostalAgencia': err.message }, { emitEvent: true })
                            this.zipCodeSearched = '';
                            this.houseService.location$.next(null);
                            this.houseService.localities$.next([]);
                            resolve(false)
                        });
                }
            }
        })

    }
}


